import ToggleButtons from "../../reusable/toggleButtons";
import InputBox from "../../reusable/InputBox";

export default function MilkEntryForm({
  t,
  inputs,
  calculationType,
  setCalculationType,
  animalType,
  setAnimalType,
  time,
  setTime,
  handleChange,
  weightRef,
  fatRef,
  snfRef,
  priceRef,
  isAutoIncrement,
  setIsAutoIncrement,
  showReceiptAfterSubmit,
  setShowReceiptAfterSubmit,
  finalTotal,
  handleSubmit,
}) {
  const isFatOnly =
    calculationType === t("milkEntry.toggles.fat") || calculationType === "fat";

  return (
    <div className="mb-6 overflow-hidden rounded-[26px] bg-white shadow-[0_12px_34px_rgba(20,35,58,0.08)] ring-1 ring-[#E9EDF3]">
      
      {/* --- 1. Ledger Header (Configuration) --- */}
      <div className="border-b border-line/80 bg-primary/[0.045] p-4">
        <div className="space-y-4">
          {/* Calc Toggle */}
          <div>
            <p className="mb-2 ml-0.5 text-[11px] font-bold text-ink">
              {t("milkEntry.headers.calc")}
            </p>
            <ToggleButtons
              name1={t("milkEntry.toggles.fat")}
              name2={t("milkEntry.toggles.fatSnf")}
              onToggle={setCalculationType}
            />
          </div>

          {/* Animal & Shift Toggles */}
          <div className="grid grid-cols-2 gap-3">
            <div>
              <p className="mb-2 ml-0.5 text-[11px] font-bold text-ink">
                {t("milkEntry.headers.animal")}
              </p>
              <ToggleButtons
                name1={t("milkEntry.toggles.cow")}
                name2={t("milkEntry.toggles.buffalo")}
                onToggle={setAnimalType}
              />
            </div>
            <div>
              <p className="mb-2 ml-0.5 text-[11px] font-bold text-ink">
                {t("milkEntry.headers.shift")}
              </p>
              <ToggleButtons
                name1={t("milkEntry.toggles.morning")}
                name2={t("milkEntry.toggles.evening")}
                onToggle={setTime}
              />
            </div>
          </div>
        </div>
      </div>

      {/* --- 2. Data Entry Section --- */}
      <form onSubmit={handleSubmit}>
        <div className="space-y-5 p-4">
          
          {/* Date Input */}
          <div className="px-1">
            <InputBox
              label={t("milkEntry.form.date")}
              type="date"
              name="date"
              value={inputs.date}
              onValueChange={handleChange}
              required
            />
          </div>

          {/* Calculation Block (Grouped Numbers) */}
          <div className="grid grid-cols-2 gap-3 rounded-[20px] bg-paper p-3.5">
            <InputBox
              reference={weightRef}
              label={t("milkEntry.form.weight")}
              type="number"
              name="weight"
              value={inputs.weight}
              onValueChange={handleChange}
              placeholder="0.00"
              required
              onNext={() => fatRef.current.focus()}
            />

            <InputBox
              reference={fatRef}
              label={t("milkEntry.form.fat")}
              type="number"
              name="fat"
              value={inputs.fat}
              onValueChange={handleChange}
              placeholder="0.0"
              required
              onNext={() =>
                isFatOnly ? priceRef.current.focus() : snfRef.current.focus()
              }
            />

            {!isFatOnly && (
              <InputBox
                reference={snfRef}
                label={t("milkEntry.form.snf")}
                type="number"
                name="snf"
                value={inputs.snf}
                onValueChange={handleChange}
                placeholder="0.0"
                required
                onNext={() => priceRef.current.focus()}
              />
            )}

            <div className={!isFatOnly ? "col-span-1" : "col-span-2"}>
              <InputBox
                reference={priceRef}
                label={t("milkEntry.form.rate")}
                type="number"
                name="price"
                value={inputs.price}
                onValueChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Settings Checkboxes */}
          <div className="flex flex-col sm:flex-row gap-4 px-1">
            <label className="group flex min-h-[36px] cursor-pointer items-center space-x-2.5">
              <input
                type="checkbox"
                checked={isAutoIncrement}
                onChange={() => setIsAutoIncrement(!isAutoIncrement)}
                className="h-[18px] w-[18px] rounded-md border-line bg-paper text-primary focus:ring-primary"
              />
              <span className="text-[12.5px] font-medium text-muted transition-colors group-hover:text-primary">
                {t("milkEntry.form.auto_next")}
              </span>
            </label>

            <label className="group flex min-h-[36px] cursor-pointer items-center space-x-2.5">
              <input
                type="checkbox"
                checked={showReceiptAfterSubmit}
                onChange={() => setShowReceiptAfterSubmit(!showReceiptAfterSubmit)}
                className="h-[18px] w-[18px] rounded-md border-line bg-paper text-primary focus:ring-primary"
              />
              <span className="text-[12.5px] font-medium text-muted transition-colors group-hover:text-primary">
                {t("milkEntry.form.gen_receipt")}
              </span>
            </label>
          </div>
        </div>

        {/* --- 3. Receipt Footer (Total & Submit) --- */}
        <div className="p-4 pt-0">
          <div className="mb-4 flex flex-col rounded-[20px] bg-credit/[0.08] p-4 ring-1 ring-credit/10">
            <p className="mb-1 text-[11px] font-bold text-credit">
              {t("milkEntry.headers.total")}
            </p>
            <div className="text-[28px] font-mono font-bold text-credit leading-none">
              ₹ {finalTotal}
            </div>
          </div>

          <button
            type="submit"
            className="app-primary-button w-full text-[15px]"
          >
            {t("milkEntry.form.save_btn")}
          </button>
        </div>
      </form>
      
    </div>
  );
}
